import { IS_DEV_BUILD } from '@/environment'
import Vue from 'vue'
import Router from 'vue-router'
import aiAssistantsRoutes from './routes/aiAssistantsRoutes'
import approvals from './routes/approvals'
import companySettingsRoutes from './routes/companySettingsRoutes'
import companySubsidiariesRoutes from './routes/companySubsidiariesRoutes'
import defaultRoutes from './routes/defaultRoutes'
import eventRoutes from './routes/eventRoutes'
import groupRoutes from './routes/groupRoutes'
import policiesRoutes from './routes/policiesRoutes'
import portalCreatorRoutes from './routes/portalCreatorRoutes'
import productRoutes from './routes/productRoutes'
import redirectRoutes from './routes/redirectRoutes'
import {
  ROUTE_ERROR,
  ROUTE_FORBIDDEN,
  ROUTE_NOT_FOUND,
  ROUTE_ROOT,
  ROUTE_UNAUTHORIZED,
} from './routes/routeNames'
import userRoutes from './routes/userRoutes'

const MainPage = () => import('@/components/layout/TheMainpageView.vue')
const NetworkErrorScreen = () =>
  import('@/components/generics/NetworkErrorScreen.vue')
const UnauthorizedPage = () => import('@/views/401View.vue')
const ForbiddenPage = () => import('@/views/403View.vue')
const NotFoundPage = () => import('@/views/404View.vue')

const DevPreviewComponent = () => import('@/components/dev/DevPreview.vue')

const Categories = () => import('@/pages/users/UserEngage.vue')

const LoadingRoute = () =>
  import('@/components/generics/TimedLoadingScreen.vue')

Vue.use(Router)

const scrollBehavior = () => {
  return { x: 0, y: 0 }
}

export const routes = [
  {
    name: ROUTE_ROOT,
    path: '/',
    component: MainPage,
    children: [
      ...approvals,
      ...userRoutes,
      ...productRoutes,
      ...eventRoutes,
      ...defaultRoutes,
      ...groupRoutes,
      ...policiesRoutes,
      ...aiAssistantsRoutes,
      ...portalCreatorRoutes,
      ...redirectRoutes,
      ...companySubsidiariesRoutes,
      ...companySettingsRoutes,
    ],
  },
  {
    name: 'app-init',
    path: '/app-init',
    component: LoadingRoute,
  },
  {
    name: ROUTE_ERROR,
    path: '/error',
    component: NetworkErrorScreen,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    name: ROUTE_NOT_FOUND,
    path: '/notfound',
    component: NotFoundPage,
  },
  {
    name: ROUTE_FORBIDDEN,
    path: '/forbidden',
    component: ForbiddenPage,
  },
  {
    name: ROUTE_UNAUTHORIZED,
    path: '/unauthorized/:allowTakeMeHome',
    component: UnauthorizedPage,
    props: (route) => ({
      allowTakeMeHome:
        route.params?.allowTakeMeHome ||
        route.params.allowTakeMeHome === 'true',
    }),
  },
  {
    path: '*',
    redirect: { name: ROUTE_ROOT },
  },
  {
    name: 'CATEGORIES',
    path: '/categories',
    component: Categories,
  },
]

IS_DEV_BUILD &&
  routes.push({
    path: '/dev-preview',
    name: 'DevPreview',
    component: DevPreviewComponent,
  })

const createRouter = (subdomain) => {
  return new Router({
    scrollBehavior,
    mode: 'history',
    base: subdomain,
    routes,
  })
}

export default createRouter
